/**
 * @generated SignedSource<<14e0b58e07f0d27198c4fa7becfbf208>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateOperatingRoomInput = {
  hospitalId: string;
  name: string;
};
export type CreateOperatingRoomModalMutation$variables = {
  input: CreateOperatingRoomInput;
};
export type CreateOperatingRoomModalMutation$data = {
  readonly createOperatingRoom: {
    readonly node: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CreateOperatingRoomModalMutation = {
  response: CreateOperatingRoomModalMutation$data;
  variables: CreateOperatingRoomModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LocationEdge",
    "kind": "LinkedField",
    "name": "createOperatingRoom",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Location",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOperatingRoomModalMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOperatingRoomModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0ca1414def1a4c8a9df173dda2bb17d8",
    "id": null,
    "metadata": {},
    "name": "CreateOperatingRoomModalMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOperatingRoomModalMutation(\n  $input: CreateOperatingRoomInput!\n) {\n  createOperatingRoom(input: $input) {\n    node {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c1176ec585e5ab3cc5daf3a6bdca1f6d";

export default node;
